import React, { useState } from 'react';
import { FileUploader } from '../common/FileUploader';
export function UploadBordereau() {
  const [mappedFields, setMappedFields] = useState([{
    source: 'First Name',
    target: 'First Name',
    mapped: true
  }, {
    source: 'Last Name',
    target: 'Last Name',
    mapped: true
  }, {
    source: 'Policy ID',
    target: 'policy_id',
    mapped: true
  }, {
    source: 'Date',
    target: 'Date',
    mapped: true
  }, {
    source: 'GWP',
    target: 'GWP',
    mapped: true
  }]);
  return <div className="bg-white rounded-lg shadow" data-id="element-472">
      <div className="p-6" data-id="element-473">
        <h2 className="text-xl font-semibold mb-6" data-id="element-474">Upload Bordereau</h2>
        <div className="mb-6" data-id="element-475">
          <p className="text-gray-600 mb-4" data-id="element-476">
            Uploading a bordereau is the fastest way to onboard your data. You
            can upload files containing premiums, claims, or both.
          </p>
          <FileUploader data-id="element-477" />
        </div>
        <div className="mt-8" data-id="element-478">
          <h3 className="text-lg font-medium mb-4" data-id="element-479">
            Map columns in your file to correct properties
          </h3>
          <div className="overflow-x-auto" data-id="element-480">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-481">
              <thead className="bg-gray-50" data-id="element-482">
                <tr data-id="element-483">
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-484">
                    Source Column
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-485">
                    Maps To
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-486">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-487">
                {mappedFields.map((field, index) => <tr key={index} data-id="element-488">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-489">
                      {field.source}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-490">
                      <select className="border rounded p-1" value={field.target} onChange={e => {
                    const newMappedFields = [...mappedFields];
                    newMappedFields[index].target = e.target.value;
                    newMappedFields[index].mapped = e.target.value !== '';
                    setMappedFields(newMappedFields);
                  }} data-id="element-491">
                        <option value="" data-id="element-492">Select field</option>
                        <option value="First Name" data-id="element-493">First Name</option>
                        <option value="Last Name" data-id="element-494">Last Name</option>
                        <option value="policy_id" data-id="element-495">Policy ID</option>
                        <option value="Date" data-id="element-496">Date</option>
                        <option value="GWP" data-id="element-497">GWP</option>
                        <option value="Brokerage" data-id="element-498">Brokerage</option>
                        <option value="IPT" data-id="element-499">IPT</option>
                        <option value="Line/Product" data-id="element-500">Line/Product</option>
                        <option value="CCY" data-id="element-501">CCY</option>
                      </select>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-502">
                      {field.mapped ? <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800" data-id="element-503">
                          Mapped
                        </span> : <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800" data-id="element-504">
                          Not Mapped
                        </span>}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
        <div className="mt-8" data-id="element-505">
          <h3 className="text-lg font-medium mb-2" data-id="element-506">Required Fields</h3>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-507">
            <div data-id="element-508">
              <h4 className="font-medium mb-2" data-id="element-509">Premiums:</h4>
              <ul className="list-disc list-inside space-y-1 text-gray-600" data-id="element-510">
                <li data-id="element-511">policy_id</li>
                <li data-id="element-512">Date</li>
                <li data-id="element-513">GWP</li>
                <li data-id="element-514">Brokerage</li>
                <li data-id="element-515">IPT</li>
                <li data-id="element-516">Line/Product</li>
                <li data-id="element-517">CCY</li>
              </ul>
            </div>
            <div data-id="element-518">
              <h4 className="font-medium mb-2" data-id="element-519">Claims:</h4>
              <ul className="list-disc list-inside space-y-1 text-gray-600" data-id="element-520">
                <li data-id="element-521">FNOL</li>
                <li data-id="element-522">Claim Date</li>
                <li data-id="element-523">Claim Value</li>
                <li data-id="element-524">Claim Paid Date</li>
                <li data-id="element-525">Claim Paid Value</li>
                <li data-id="element-526">CCY</li>
              </ul>
            </div>
          </div>
          <p className="mt-4 text-sm text-gray-500" data-id="element-527">
            Note: If your file contains both premiums and claims in the same
            file, you'll need to upload it twice and map the appropriate fields
            each time.
          </p>
        </div>
      </div>
    </div>;
}